(ns manage.content-variant-page.version-switcher.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            [manage.content-variant-page.version-switcher.db]
            [re-frame.core :as rf]))

(defn- sort-versions-names
  "Sorts the version names so that 'published' comes first, then alphabetically."
  [version-names]
  (->> version-names
       (sort-by (fn [version-name]
                  [(if (= version-name "published") 0 1)
                   version-name]))))

(defn- resource-pending? [k]
  @(rf/subscribe [:resource.content-function/pending? k]))

(defn- published-action-buttons []
  [:> Button
   {:variant "contained"
    :color "grey"
    :size "small"
    :data-testid "targeting-edit-button"
    :disabled (resource-pending? :create-stage)
    :on-click (fn [^js _event]
                (rf/dispatch [:page.content-variant.targeting/edit-as-draft]))}
   "Edit"])

(defn- draft-action-buttons [draft-version]
  (let [can-publish @(rf/subscribe [:content-configuration/can-publish? [:content-configuration/id "default"]])
        has-published-version @(rf/subscribe [:resource.content-function-version/contains-version? "published"])]
    [:<>
     [:> Button {:variant "contained"
                 :size "small"
                 :color "grey"
                 :disabled (or (not can-publish)
                               (resource-pending? :publish-stage))
                 :data-testid "targeting-publish-button"
                 :on-click (fn [^js _event]
                             (rf/dispatch [:page.content-variant.targeting/publish-version draft-version]))}
      "Publish"]
     [:> Button {:variant "text"
                 :size "small"
                 :data-testid "targeting-discard-button"
                 :disabled (or (resource-pending? :delete-stage)
                               (not has-published-version))
                 :on-click (fn [^js _event]
                             (rf/dispatch [:page.content-variant.targeting/discard-version draft-version]))
                 :sx {:color "grey.10"
                      :fontWeight 500}}
      "Discard"]]))

(defn action-bar []
  (when-some [cf-active-version (-> @(rf/subscribe [:resource.content-function-version/active-version])
                                    :name)]
    (let [version-names (-> @(rf/subscribe [:resource.content-function-version/version-names])
                            sort-versions-names)]
      [:> Stack {:direction "row"
                 :spacing 1
                 :align-items "stretch"}
       [:> Select {:value cf-active-version
                   :variant "filled"
                   :sx {:minWidth "112px"}
                   :size "small"
                   :on-change (fn [^js event]
                                (let [version-name (-> event .-target .-value)]
                                  (rf/dispatch [:resource.content-function-version/activate-version version-name])))}
        (for [version-name version-names]
          ^{:key version-name}
          [:> MenuItem {:value version-name}
           version-name])]
       [:> Divider {:orientation "vertical"
                    :variant "middle"
                    :flexItem true}]
       (if (= cf-active-version "published")
         [published-action-buttons]
         [draft-action-buttons cf-active-version])])))

